import { useState } from 'react';
import { Action } from '../../../../clients';
import { AgencyManagementHeading, AgencyManagementTable } from '../../../../components/AgencyManagementTable';
import { useProfile } from '../../../../hooks';
import { hasPermission } from '../../../../utils/auth';

export function AgencyUserManagement(): JSX.Element {
  const { profileData, isGetProfileLoading } = useProfile();
  const [search, setSearch] = useState<{ search: string; filter: string }>({
    search: '',
    filter: '',
  });

  const handleFiltersChange = (searchText: string, filter: string) => {
    setSearch({ search: searchText, filter: filter });
  };

  return (
    <>
      <AgencyManagementHeading
        canCreateAgency={
          !isGetProfileLoading && profileData !== undefined && hasPermission(profileData.userType, Action.CREATE)
        }
        onFilterChange={handleFiltersChange}
      />
      <AgencyManagementTable
        currentSessionUser={profileData}
        isGetProfileLoading={isGetProfileLoading}
        filter={search.filter}
        search={search.search}
      />
    </>
  );
}
